var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShareFilledM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 23a5 5 0 00-4.09 2.14l-7-4.06a4.55 4.55 0 000-2.16l7-4.06A5 5 0 1023 12a5.49 5.49 0 00.1 1l-7 4.08a5 5 0 100 5.82l7 4.1a5.49 5.49 0 00-.1 1 5 5 0 105-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h40v40H0z"
  })));
}

export default SvgIconShareFilledM;